import React from 'react';
import './PullOnLoading.scss';
import Loading from 'common/components/loading/Loading';
import BottomDownload from 'common/components/bottom-download/BottomDownload';
import $ from 'jquery';
import utils from 'common/js/utils';


export default class PullOnLoadingTips extends React.Component {
    componentDidMount () {
        this.updateLoadingShowMode();
    }

    componentDidUpdate () {
        this.updateLoadingShowMode();
    }

    render(){;
        const hasMore = this.props.bIsMore;

        return (
            <div ref="loading" className={ hasMore && !this.props.bInited ? "m-pull-loading full" : "m-pull-loading" }>
                { hasMore ? <Loading /> : <BottomDownload />}
            </div>
        );
    }

    updateLoadingShowMode() {
        const props = this.props;
        const $loading = this.refs.loading;
        $loading.style.display = 'block';
        if( props.bInited  && !props.bIsMore && $(document).height() <= document.documentElement.clientHeight && $loading ) {
            $loading.style.display = 'none';
        }
    }
}


// WEBPACK FOOTER //
// ./src/common/components/pull-on-loading/PullOnLoadingTips.jsx